import { MobileBridge } from "@wwg/mobile-bridge";

const bridge = new MobileBridge({
  verbose: true,
});

export default bridge;
